import { render } from "./DropFilesShow.vue?vue&type=template&id=4b3b2395"
import script from "./DropFilesShow.vue?vue&type=script&lang=js"
export * from "./DropFilesShow.vue?vue&type=script&lang=js"

import "./DropFilesShow.vue?vue&type=style&index=0&id=4b3b2395&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__